import { JSX } from 'react';
import { FREETEXT_KEYS } from '~/const/freetext';
import { STAND_ADMIN_ERROR_KEY } from '~/const/standAdmin';
import { getStore } from '~/mobx/AppStore';
import { NO_ACTIVE_ELECTION_ERROR_REASON } from './getNoActiveElectionError';
import { LOGIN_ERROR_KEY } from '~/const/login';
import SafeHTML from '~/components/SafeHTML/SafeHTML';

const getLoginErrorMessage = (): JSX.Element | string | null => {
    const { ballotStore, freetextStore } = getStore();
    const noActiveElectionError = ballotStore.getNoActiveElectionError();
    const noActiveElectionErrorMessage = freetextStore.getFreetextValueByKey(
        FREETEXT_KEYS.login_form_no_active_election
    );

    const loginError = ballotStore.loginError;
    if (loginError === LOGIN_ERROR_KEY.no_valid_membership) {
        return noActiveElectionErrorMessage;
    }

    const standAdminLoginError = ballotStore.standAdminLoginError;

    if (standAdminLoginError) {
        if (
            standAdminLoginError === STAND_ADMIN_ERROR_KEY.stand_admin_company_id_mismatch ||
            standAdminLoginError === LOGIN_ERROR_KEY.no_valid_membership
        ) {
            return noActiveElectionErrorMessage;
        }
        const standAdminLoginErrorMessage = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.stand_admin_login_error);
        return <SafeHTML html={standAdminLoginErrorMessage} />;
    }

    const isStandAdmin = ballotStore.getIsStandAdmin();

    if (noActiveElectionError.isError && isStandAdmin) {
        return noActiveElectionErrorMessage;
    }

    const isLoggedIn = ballotStore.getIsLoggedIn();
    if (!noActiveElectionError.isError || !isLoggedIn) return null;

    if (noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.NO_ELECTION]) {
        return noActiveElectionErrorMessage;
    }

    if (
        noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.PAST_ELECTION_SAME_YEAR] ||
        noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.FUTURE_ELECTION_SAME_YEAR]
    ) {
        if (noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.NO_REGION]) {
            return freetextStore.getFreetextValueByKey(FREETEXT_KEYS.login_form_incorrect_region);
        }
        return noActiveElectionErrorMessage;
    }

    if (
        noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.PAST_ELECTION_DIFF_YEAR] ||
        noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.FUTURE_ELECTION_DIFF_YEAR]
    ) {
        return noActiveElectionErrorMessage;
    }

    if (noActiveElectionError.reasons[NO_ACTIVE_ELECTION_ERROR_REASON.NO_REGION]) {
        return freetextStore.getFreetextValueByKey(FREETEXT_KEYS.login_form_incorrect_region);
    }

    return null;
};

export default getLoginErrorMessage;
